import styled from 'styled-components';
import { black, white } from 'Styles/colors';
import BaseIcon from '../Icons/Icon';

// Exported for use in other components -- especially scrolling behavior
export const HEADER_HEIGHT = 64;

export const Header = styled.div`
  position: sticky;
  top: 0;
  z-index: 999;

  background-color: ${white};
  width: 100%;
  height: ${HEADER_HEIGHT}px;
`;

export const Icon = styled(BaseIcon)`
  display: inline-block;
  transform: translateY(3px);
  color: ${black};
`;
